import styled, { keyframes } from "styled-components";

import designSystemColors from "../../../styles";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const FormWapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
`;

const CommonButton = styled.button`
  width: 30%;
  height: 40px;
  border-radius: 4px;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  transition: 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-style: solid;
  border-width: 1px;

  &:hover {
    opacity: 0.5;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(CommonButton)`
  border-color: ${designSystemColors.secondaryButtons};
  background-color: ${designSystemColors.background};
  color: ${designSystemColors.secondaryButtons};
`;

export const SubmitButton = styled(CommonButton)`
  border-color: ${designSystemColors.secondaryButtons};
  background-color: ${designSystemColors.secondaryButtons};
  color: ${designSystemColors.textGeneralButtons};
`;

export const Loader = styled.div`
  border: 4px solid ${designSystemColors.background};
  border-top: 4px solid ${designSystemColors.secondaryButtons};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 1.5s linear infinite;
`;
